/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum HoldingEventType {
    ISSUANCE_OF_SHARE_CERTIFICATES = 'ISSUANCE_OF_SHARE_CERTIFICATES',
    PLEDGING_OF_SHARES = 'PLEDGING_OF_SHARES',
    ASSIGNMENT_OF_VOTING_RIGHTS = 'ASSIGNMENT_OF_VOTING_RIGHTS',
    NOTE = 'NOTE',
}
